export default __webpack_public_path__ + "static/media/lodgify.35c14924.png";